import TemplatesModel from './templates.model.js';
import VariablesModel from './variables.model.js';
const model = {
    name: 'Appearance',
    properties: {
        templates: { type: 'model', model: TemplatesModel },
        variables: { type: 'model', model: VariablesModel },
    },
};
export default model;
